<script>
import { mapActions } from 'vuex'

import { use } from 'echarts/core'
import { CanvasRenderer } from 'echarts/renderers'
import { BarChart, LineChart } from 'echarts/charts'
import {
  GridComponent,
  ToolboxComponent,
  TooltipComponent,
  LegendComponent,
  LegendScrollComponent,
  DataZoomComponent,
  DataZoomInsideComponent,
  DataZoomSliderComponent,
  DatasetComponent,
} from 'echarts/components'
import MChart, { THEME_KEY } from 'vue-echarts'

use([
  GridComponent,
  ToolboxComponent,
  TooltipComponent,
  LegendComponent,
  LegendScrollComponent,
  DataZoomComponent,
  DataZoomInsideComponent,
  DataZoomSliderComponent,
  DatasetComponent,
  CanvasRenderer,
  BarChart,
  LineChart,
])
export default {
  components: {
    MChart,
  },
  props: {
    playerId: {
      type: Number,
      default: () => null,
      required: true,
    },
  },
  data() {
    return {
      isLoading: true,
      option: {
        tooltip: {
          trigger: 'axis',
          position: function(pt) {
            return [pt[0], '10%']
          },
        },
        grid: {
          top: 30,
          bottom: 10,
          left: 10,
          containLabel: true,
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: [],
          axisLabel: {
            formatter: function(value) {
              return value - 1 + '/' + value
            },
          },
        },
        yAxis: {
          type: 'value',
          inverse: false,
          min: 0,
          max: 100,
          interval: 10,
          scale: false,
          axisLabel: {
            show: true,
          },
          offset: 10,
        },
        series: [
          {
            name: 'Index Performance',
            type: 'line',
            smooth: true,
            symbolSize: 40,
            symbol: 'pin',
            itemStyle: {
              color: '#72CEFF',
              barBorderRadius: 0,
            },
            label: {
              show: true,
              position: 'inside',
              fontSize: 10,
              formatter: function(p) {
                return p.value > 0 ? p.value : ''
              },
            },
            data: [],
            markPoint: {
              data: [
                {
                  type: 'max',
                  name: 'Best Index',
                  symbol: 'arrow',
                  symbolSize: 20,
                  symbolOffset: [0, 0],
                  itemStyle: {
                    color: '#0c960f',
                    label: {
                      show: false,
                    },
                  },
                },
                {
                  type: 'min',
                  name: 'Min Index',
                  symbol: 'arrow',
                  symbolOffset: [0, 0],
                  // symbolRotate: 180,
                  symbolSize: 20,
                  itemStyle: {
                    color: '#e00f0f',
                    label: {
                      show: false,
                    },
                  },
                },
              ],
            },
          },
        ],
      },
    }
  },
  provide: {
    [THEME_KEY]: 'light',
  },
  async created() {
    this.getPlayerStatData({ id: this.playerId }).then((response) => {
      const data = {
        seasons: [],
        values: [],
      }

      response.performances_season.forEach((element) => {
        data.seasons.push(element.season)
        data.values.push(element.value.toFixed(1))
      })

      this.option.xAxis.data = data.seasons
      this.option.series[0].data = data.values
      this.isLoading = false
      this.$emit('loaded', !this.isLoading)
    })
  },
  methods: {
    ...mapActions('players', ['getPlayerStatData']),
    onResize() {
      if (typeof this.$refs.chart !== 'undefined') this.$refs.chart.resize()
    },
  },
}
</script>

<template>
  <v-responsive
    v-resize="onResize"
    aspect-ratio="4/3"
    :class="$style.responsive"
  >
    <MChart
      v-if="!isLoading"
      ref="chart"
      :class="$style.chart"
      :option="option"
    />
  </v-responsive>
</template>

<style lang="scss" module>
@import '@design';

.chart {
  margin: 0 auto;
}

.responsive {
  height: 100%;
  overflow: visible;

  @media screen and (max-width: $screen-lg) {
    min-height: 12rem;
  }
}
</style>
